// extracted by mini-css-extract-plugin
module.exports = {"errors":"index_errors_4DHyd","container":"index_container_3dNjN","footerNav":"index_footerNav_2pls5"};